import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelfServiceLanguage } from '../../context/SelfServiceLanguageContext';
import SelfServiceFooter from '../../components/SelfServiceFooter';
import vkqr from '@vkontakte/vk-qr';
import './SelfService.css';

const SelfServiceCompleteScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useSelfServiceLanguage();

    const [qrCodeSvg, setQrCodeSvg] = useState('');
    const [countdown, setCountdown] = useState(10);

    const saleId = location.state?.saleId;
    const receiptUrl = location.state?.receiptUrl;
    const totalAmount = location.state?.totalAmount;

    useEffect(() => {
        // Generate QR code for receipt using vkqr
        if (receiptUrl || saleId) {
            const url = receiptUrl || `https://receipt.minimarket116.kz/dlvr/v2/${saleId}`;

            try {
                const qrSvg = vkqr.createQR(url, {
                    qrSize: 256,
                    className: 'qr-code',
                    isShowLogo: false,
                    logoData: '',
                    foregroundColor: '#0B6A32',
                    backgroundColor: '#FFFFFF'
                });

                setQrCodeSvg(qrSvg);
            } catch (error) {
                console.error('Error generating QR code:', error);
            }
        }
    }, [receiptUrl, saleId]);

    useEffect(() => {
        // Countdown timer
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    // Clear cart and return to waiting screen
                    localStorage.removeItem('self_service_cart');
                    navigate('/device/self-service');
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [navigate]);

    const handleStartNewPurchase = () => {
        localStorage.removeItem('self_service_cart');
        navigate('/device/self-service');
    };

    return (
        <div className="self-service-container">
            {/* Header */}
            <div className="self-service-header">
                <div className="self-service-logo">
                    {t('minimarket')} <span className="self-service-logo-highlight">116</span>
                </div>
            </div>

            {/* Content */}
            <div className="self-service-content">
                <h1 className="self-service-title" style={{ fontSize: 64 }}>
                    {t('thankYouForPurchase')}
                </h1>

                {/* Fiscal receipt section */}
                <div style={{ marginBottom: 32 }}>
                    <h2 style={{
                        fontSize: 28,
                        fontWeight: 600,
                        color: 'white',
                        textAlign: 'center',
                        marginBottom: 24
                    }}>
                        {t('fiscalReceipt')}
                    </h2>

                    {/* QR Code */}
                    {qrCodeSvg && (
                        <div className="self-service-qr" dangerouslySetInnerHTML={{ __html: qrCodeSvg }} />
                    )}
                </div>

                {/* Countdown */}
                <div className="self-service-countdown">
                    {t('startNewPurchase')} {countdown} {t('seconds')}
                </div>

                {/* Start new purchase button */}
                <button
                    className="self-service-button"
                    onClick={handleStartNewPurchase}
                >
                    {t('startNewPurchaseButton')}
                </button>
            </div>

            {/* Footer */}
            <SelfServiceFooter />
        </div>
    );
};

export default SelfServiceCompleteScreen;
